if (navigator.userAgent.match(/(iPod|iPhone|iPad|Mac)/)) {
jQuery('html').addClass('mac');
}
// product offer

  var swiper = new Swiper(".offer_code_block", {
    slidesPerView: 1,
    spaceBetween: 6,
    speed: 800,
    navigation: {
      nextEl: ".offer_code_block_main .swiper-button-next",
      prevEl: ".offer_code_block_main .swiper-button-prev",
    },
    breakpoints: {
      576: {
        slidesPerView: 1,
        spaceBetween: 12,
      }
    },
  });

// accordion 
                                    
  $('.custom_accordion .accordion-header').on('click', function() {
      var $accordionItem = $(this).closest('.accordion-item');
      $accordionItem.toggleClass('open');
      $accordionItem.find('.accordion-content').slideToggle();

      // Close other accordions
      $('.accordion-item').not($accordionItem).removeClass('open').find('.accordion-content').slideUp();
  });


// size chart js 
$( document ).ready(function() {
  $('.size_chart_block').on('click', function(e) {
  e.preventDefault();
  $('.size_chart_popup').addClass('popup_open');
  $('body').css('overflow', 'hidden');
  $('body').addClass('size_chart_popup_open');
});

// Event for closing the popup
$('.chart_close_icon, .size_chart_popup').on('click', function(e) {
  // Close when clicking on the close icon or any of its child elements, including svg
  if ($(e.target).closest('.chart_close_icon').length || $(e.target).hasClass('size_chart_popup')) {
    $('.size_chart_popup').removeClass('popup_open');
    $('body').css('overflow', 'unset');
    $('body').removeClass('size_chart_popup_open');
  }
});
});

//--------------------------
var features_slider_swiper = new Swiper(".product_features_slider", {
      slidesPerView: 1.2,
      spaceBetween: 4,
      centeredSlides: true,
      speed: 1200,
      pagination: {
        el: ".product_features_slider .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 8,
          centeredSlides: false,
          loop: false,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: false,
          loop: false,
        },
      },
    });

 // Menu slide toggle on click
$(".mobileMenu-toggle").on("click", function () {
  $("#navigation-mobile").slideToggle(1000);
  $("body").toggleClass("menu_open");
});

// Function to close the menu
function closeMenu() {
  if ($("body").hasClass("menu_open")) {
    $("body").removeClass("menu_open");
    $("#navigation-mobile").slideUp(1000);
  }
}

// Event listener for scroll to close the menu
$(window).on("scroll", function () {
  closeMenu();
});



$('.js-search-header').click(function () {
  setTimeout(function () {
    $(".search-block-content .products-grid").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev slick-arrow" aria-label="Previous"><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.36364 10.3636L1.61712 6.61711C1.2763 6.27629 1.2763 5.72371 1.61712 5.38289L5.36364 1.63636M1.87273 6L13 6" stroke="#EF3B4C" stroke-width="1.5" stroke-linecap="round"></path></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next slick-arrow" aria-label="Next"><svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.36364 10.3636L1.61712 6.61711C1.2763 6.27629 1.2763 5.72371 1.61712 5.38289L5.36364 1.63636M1.87273 6L13 6" stroke="#EF3B4C" stroke-width="1.5" stroke-linecap="round"></path></svg></button>',
      autoplay: false,
      dots: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            arrows: true,
            dots: true,
            centerMode: false,
          },
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            arrows: true,
            dots: true,
            centerMode: true,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            autoplay: false,
            arrows: true,
            dots: true,
            centerMode: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            autoplay: false,
            arrows: true,
            dots: true,
            centerMode: true,
            infinite: true,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            autoplay: false,
            arrows: true,
            dots: true,
            centerMode: true,
          },
        },
      ],
    });
  }, 100); // Set timeout for 500ms
});


// =========================== Header Sticky Js



// function adjustMainContentPadding() {
//     let header = document.querySelector('.header-wrapper');
//     let mainContent = document.querySelector('#MainContent');

//     if (header && mainContent) {
//         let headerHeight = header.offsetHeight;
//         mainContent.style.paddingTop = headerHeight + 'px';
//     }
// }

// // Initial call
// adjustMainContentPadding();

// // Window resize par bhi update karega
// window.addEventListener('resize', adjustMainContentPadding);


function isNumberKey(evt){
var charCode = (evt.which) ? evt.which : evt.keyCode
if (charCode > 31 && (charCode < 48 || charCode> 57))
return false;
return true;
}
